import React, { useEffect, useState } from 'react';
import { Container, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

function DevicesPage() {
    const baseUrl = process.env.REACT_APP_BACKEND_URL;
    const { user } = useAuth();

    const [devices, setDevices] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Fetch the NFL replays from the backend
        fetch(baseUrl + '/device', { credentials: 'include' })
        .then(response => {
            if (!response.ok) {
            throw new Error('Network response was not ok');
            }
            return response.json(); // Assuming the API returns JSON
        })
        .then(data => setDevices(data))
        .catch(err => {
            setError(err.message);
        });
    }, [baseUrl]);

return (
    <Container className="brand-page mt-5">
        <h1>Devices</h1>
        <p>Welcome to the Devices Page!</p>

        {/* Display error if fetching fails */}
        {error && <Alert variant="danger">Error: {error}</Alert>}

        {/* Button to create a new device */}
        {user?.role === 'admin' && <div className="mb-3">
            <Link to="/devices/create" className="btn btn-primary">
                Create New Device
            </Link>
        </div>}

        {/* Display table of devices */}
        {devices.length > 0 ? (
            <table className="table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>IPTV</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {devices.map((device, index) => (
                        <tr key={index}>
                            <td>{device.id}</td>
                            <td>{device.deviceName}</td>
                            <td>{device.iptvLink.substring(0, 10)}...</td>
                            <td>
                                {user?.role === 'admin' && <><Link to={`/devices/edit/${device.deviceName}`}>
                                    Edit
                                </Link>{' / '}</>}
                                <Link to={`/epg/${device.deviceName}`}>
                                    EPG
                                </Link>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        ) : (
            <p>No devices available.</p>
        )}
    </Container>
);
}

export default DevicesPage;
